module.exports = __webpack_public_path__ + "images/build_for_students_desktop.webp";